import { BehaviorSubject } from 'rxjs';
import { HomepageApiService } from './homepage-api-service';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';

export class HomepageDataSource extends DataSource<any> {
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  protected Data: BehaviorSubject<[]> = new BehaviorSubject([]);
  constructor(
    protected HomepageApi: HomepageApiService,
    protected role: string
  ) {
    super();
  }

  public load() {
    this.loading.next(true);
    this.HomepageApi.load(this.role).then(
      ({ data }) => {
        this.Data.next(data);
        this.loading.next(false);
      },
      (error) => this.loading.next(false)
    );
  }

  public updateListingImage(carouselId, image) {
    return this.HomepageApi.updateListingImage(carouselId, image).then(() =>
      this.load()
    );
  }

  public removeImage(carouselId) {
    return this.HomepageApi.removeListingImage(carouselId).then(() =>
      this.load()
    );
  }
  public setOrder(ProductInfos, categoryId) {
    this.loading.next(true);

    return this.HomepageApi.order('admin', ProductInfos, categoryId).then(() =>
      this.load()
    );
  }
  public save(Product, catId) {
    return this.HomepageApi.save(Product, catId).then(() => this.load());
  }

  public delete(carouselId) {
    return this.HomepageApi.delete(carouselId).then(() =>
      this.load()
    );
  }

  /**
   * Connects a collection viewer (such as a data-table) to this data source.
   * @param collectionViewer The component that exposes a view over the data provided by this
   *     data source.
   * @returns Observable that emits a new value when the data changes.
   */
  public connect(collectionViewer?: CollectionViewer) {
    return this.Data;
  }

  /**
   * Disconnects a collection viewer (such as a data-table) from this data source. Can be used
   * to perform any clean-up or tear-down operations when a view is being destroyed.
   *
   * @param collectionViewer The component that exposes a view over the data provided by this
   *     data source.
   */
  public disconnect(collectionViewer?: CollectionViewer) {}
}
